export default function normalizeNumber(value: string, decimalPlaces?: number): number | null {
    let res: number | null = null

    if (value) {
        // ignore , to accept 2,000 as 2000
        let str = value.toString().replace(/,/g, "")

        let num = parseFloat(str)
        if (!isNaN(num)) {
            if (typeof decimalPlaces === "number" && !isNaN(decimalPlaces)) {
                // Round to the specified decimal places
                num = parseFloat(num.toFixed(decimalPlaces))
            }
            res = num
        }
    }
    return res
}
